import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { comnUtils, comnEnvs } from "@/comn/utils";
import { Grid } from "@/comn/components";
import { Page, Group, Layout, Button } from "@/comn/components";
import { useForm, useFetch, usePopup, useStore, useToast, useAuth, useGrid, useModal, useResource } from "@/comn/hooks";
import { BASE, APIS, SCHEMA_FORM_CSTM_CD_SRCH, SCHEMA_GRID_CSTM_CD } from "./services/ComnCdService";
import { Link } from "react-router-dom";

export const CustomsCodeList = (props: any) => {
    const pgeUid = "cstmCdLst";
    const { t } = useTranslation();
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid });
    const toast = useToast();
    const modal = useModal();
    const params = props.params;

    useResource({
        defaultSchema: [{ area: "comnCd", comnCd: "COM0016" }],
    });

    const form = {
        cstmCdSrch: useForm({
            defaultSchema: SCHEMA_FORM_CSTM_CD_SRCH,
            // defaultValues: { ...pgeStore?.form } || {},
        }),
    };

    const grid = {
        cstmCdLst: useGrid({
            defaultSchema: SCHEMA_GRID_CSTM_CD,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };

    const fetch = {
        getCstmCdLst: useFetch({
            api: (page = grid.cstmCdLst.page) => {
                return APIS.getCstmCdLst(form.cstmCdSrch.getValues(), page, grid.cstmCdLst.size);
            },
            enabled: comnUtils.isEmpty(form.cstmCdSrch.errors) && form.cstmCdSrch.isSubmitted,
            key: [grid.cstmCdLst.page, grid.cstmCdLst.size],
            onSuccess: () => {
                setStore(pgeUid, {
                    form: form.cstmCdSrch.getValues(),
                    page: grid.cstmCdLst.page,
                    size: grid.cstmCdLst.size,
                });
            },
        }),
    };

    const handler = {
        click_Btn_Srch: () => {
            form.cstmCdSrch.handleSubmit(
                () => {
                    grid.cstmCdLst.setPage(0);
                    fetch.getCstmCdLst.fetch(0);
                },
                () => {
                    toast.showToast({ type: "warning", content: "msg.00002" });
                },
            )();
        },

        /* * */
        click_Btn_Apply: () => {
            const list: any[] = grid.cstmCdLst.getChecked() || [];
            if (comnUtils.isEmpty(list)) {
                modal.openModal({ content: "msg.com.00086" });
                return;
            }

            props?.callback?.({ data: list });
            modal.closeModal(props.id);
        },
    };

    const render = {
        grid_CstmCdLst: {
            cell: {
                cstmOfceCd: (arg: any) => {
                    const { binding, rowValues, value } = arg;
                    return (
                        <Link
                            to={"#"}
                            onClick={(e) => {
                                e.preventDefault();
                                props?.callback?.({ code: value, label: rowValues.cstmNm });
                                modal.closeModal(props.id);
                            }}
                        >
                            {arg.value}
                        </Link>
                    );
                },
            },
        },
    };

    useEffect(() => {
        if (params?.cstmOfceCd) {
            form.cstmCdSrch.setValue("cstmOfceCd", params.cstmOfceCd);
        }

        if (params?.dclrYn) {
            form.cstmCdSrch.setValue("dclrYn", params.dclrYn);
        }
        if (params?.cstmTpCd) {
            form.cstmCdSrch.setValue("cstmTpCd", params.cstmTpCd);
            form.cstmCdSrch.setSchema("cstmTpCd", { readOnly: true, disabled: true });
        }
        if (params?.cstmOfceCdArr) {
            form.cstmCdSrch.setValue("cstmOfceCdArr", params.cstmOfceCdArr);
        }

        handler.click_Btn_Srch();
        /* * */
        if (params?.multiple === true) {
            grid.cstmCdLst.setOption("checkbox", true);
        }
    }, []);

    return (
        <Page title={t("T_CSTM_CD_LST")} info={true}>
            <form>
                <Group>
                    <Group.Body>
                        <Group.Section>
                            <Group.Row>
                                <Group.Control {...form.cstmCdSrch.schema.cstmOfceCd}></Group.Control>
                                <Group.Control {...form.cstmCdSrch.schema.cstmNm}></Group.Control>
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.cstmCdSrch.schema.cstmTpCd} controlSize={10}></Group.Control>
                            </Group.Row>
                        </Group.Section>
                        <Layout direction="row">
                            <Layout.Left>
                                <Button
                                    role="reset"
                                    onClick={() => {
                                        form.cstmCdSrch.reset();
                                    }}
                                ></Button>
                            </Layout.Left>
                            <Layout.Right>
                                <Button
                                    role="search"
                                    onClick={() => {
                                        handler.click_Btn_Srch();
                                    }}
                                ></Button>
                            </Layout.Right>
                        </Layout>
                    </Group.Body>
                </Group>
            </form>

            <Group>
                <Group.Body>
                    <Group.Section>
                        {/* * */}
                        {params?.multiple === true && (
                            <Layout>
                                <Layout.Right>
                                    <Button
                                        role="apply"
                                        onClick={() => {
                                            handler.click_Btn_Apply();
                                        }}
                                    ></Button>
                                </Layout.Right>
                            </Layout>
                        )}
                        <Grid
                            {...grid.cstmCdLst.grid}
                            data={fetch.getCstmCdLst.data?.cstmCdList}
                            render={render.grid_CstmCdLst}
                        />
                    </Group.Section>
                </Group.Body>
            </Group>
        </Page>
    );
};
